import React, { useState, useEffect} from 'react';

import cloneDeep from 'lodash/cloneDeep';

import post from '../logic/Loader';
import GlobalData from '../logic/GlobalData';

const useConstructor = (callBack = () => {}) => {
  const [hasBeenCalled, setHasBeenCalled] = useState(false);
  if (hasBeenCalled) return;
  callBack();
  setHasBeenCalled(true);
}

export default function Header(props) {

  const [user, setUser] = React.useState(GlobalData.data.user);
  const [loginForm, setLoginForm] = React.useState(false);
  const [logOrReg, setLogOrReg] = React.useState('log');
  const [loginError, seLoginError] = React.useState(false);


  function login() {
    let email = document.querySelector('.loginForm .login').value;
    let password = document.querySelector('.loginForm .password').value;

    let params = {email:email, password:password};

    post('/post/login/login/', params, (data) => {
      if(data.error)
      {
        seLoginError(data.error);
      }
      else
      {
        if(data.user) {
          GlobalData.data.user = data.user;
          GlobalData.data.stat = data.stat;
          setUser(GlobalData.data.user);

          if(GlobalData.funct.setStat)
            GlobalData.funct.setStat(data.stat);
        }
      }
    });
  }

  function register() {

    let email = document.querySelector('.loginForm .login').value;
    let password = document.querySelector('.loginForm .password').value;

    let params = {email:email, password:password};

    post('/post/login/register/', params, (data) => {
      if(data.error)
      {
        seLoginError(data.error);
      }
      else
      {
        if(data.user) {
          GlobalData.data.user = data.user;
          GlobalData.data.stat = data.stat;
          setUser(GlobalData.data.user);
        }
      }
    });
  }

  function logout() {
    let params = {};

    post('/post/login/logout/', params, (data) => {
      if(data.error)
      {
        seLoginError(data.error);
      }
      else
      {
        GlobalData.data.user = false;
        GlobalData.data.stat = {};
        setUser(false);

        if(GlobalData.funct.setStat)
          GlobalData.funct.setStat({});
      }
    });
  }

  useConstructor(() => {
  }, []);
  
  return (
    <header className="header">
      {user &&
        <>
          <div className="userName" onClick={logout}>{user.login} - выйти</div>
        </>
      }
      {!user &&
        <>
          <div className="userName" onClick={() => setLoginForm(true)}>login/register</div>

          {loginForm && 
          <>
            <div className="overbg" onClick={() => setLoginForm(false)}></div>
            <div className={`loginForm ${logOrReg}`}>

              <div className="login_title">E-MAIL</div>
              <input className="login" type="input" />

              <div  className="password_title">password</div>
              <input className="password" type="password" />

              {loginError && 
                <div className="login_error">{loginError}</div>
              }

              {logOrReg == "log" && 
                <>
                  <div className="log_but" onClick={login}>LOGIN</div>
                  <div className="go2reg" onClick={() => setLogOrReg('reg')}>go to register</div>
                </>
              }

              {logOrReg == "reg" && 
                <>
                  <div className="reg_but" onClick={register}>REGISTER</div>
                  <div className="go2log" onClick={() => setLogOrReg('log')}>go to login</div>
                </>
              }
            </div>
          </>
          }
        </>
      }
    </header>
  );
}